<div class="d-flex justify-content-between align-items-center mb-3 flex-wrap header-container">
  <div class="text-div">
    <h5 class="title">{{ title | translate }}</h5>
    <p class="subtitle text-muted">Powering Connectivity, Empowering Operations</p>
  </div>
  <div class="d-flex gap-2 button-div">
    <div class="download-button" *ngIf="!hideAddNew">
      <div class="main-button">
        <button *ngIf="!hideDropdown" class="dropdown-toggle" (click)="toggleDropdown()"></button>
        <button (click)="onAddNewClick()">
          {{'COMMON.ADD_NEW' | translate}} {{addNewText | translate}}
        </button>
      </div>
      <div class="dropdown-button-menu" *ngIf="dropdownOpen">
        <div class="dropdown-button-item" (click)="onUploadClick()">
          <span class="icon">
            <img src="../../../assets/icons/upload-arrow.svg" alt="upload icon" />
          </span> {{'COMMON.UPLOAD_XLSX' | translate}} <span class="ext">XLSX</span>
        </div>
      </div>
    </div>
  </div>
</div>